const pover_on = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M15%201.14922V9H20.0806L9%2022.8508V15H3.91937L15%201.14922ZM13%206.85078L8.08062%2013H11V17.1492L15.9194%2011H13V6.85078Z'/%3e%3c/svg%3e";
export {
  pover_on as default
};
//# sourceMappingURL=pover_on.svg.es.js.map
